export default {
    articles: {
        merchant: [],
        courier: [],
    },
}
